import { h, t, T, domWithScope } from '@jsx6/jsx6'

/**
 *
 * @param {Element} logo
 * @param {ChatBox} chat
 * @returns Element
 */
export const areaError = (chat) => {
  return (
    <div p='area.error' hidden>
      <div class='chatHeading'>
        <div class='heading-content' p='formWelcomeMessage'></div>
        <div class='chatTopbar'>
          <span p='bt.minimize' onclick={e => chat.minimize('areaForm')} icon='x-mark' />
        </div>
      </div>
      <div p='errorText' class='survey-heading'>
        {T`error_text`}
      </div>
    </div>
  )
}
